import injected from "./injected";
import boltx from "./boltx";
import walletconnect from "./walletconnect";
import portis from "./portis";
import fortmatic from "./fortmatic";
import torus from "./torus";
import venly from "./venly";
import authereum from "./authereum";
import burnerconnect from "./burnerconnect";
import mewconnect from "./mewconnect";
import dcentwallet from "./dcentwallet";
import bitski from "./bitski";
import frame from "./frame";
import wanmask from './wanmask';
import wanwallet from "./wanwallet";
import ezdefi from './ezdefi';
import clover from './clover';
import xdc from './xdc';
import metax from './metax';
import metamask from './metamask';
import binancechainwallet from "./binancechainwallet";
import coinbasewallet, { walletlink } from "./coinbasewallet";
import sequence from "./sequence";
import magic from './magic';

export {
  injected,
  walletconnect,
  boltx,
  portis,
  torus,
  fortmatic,
  venly,
  authereum,
  burnerconnect,
  mewconnect,
  dcentwallet,
  bitski,
  frame,
  metamask,
  wanmask,
  wanwallet,
  ezdefi,
  clover,
  xdc,
  metax,
  binancechainwallet,
  coinbasewallet,
  walletlink,
  sequence,
  magic,
};
